import { AfterViewInit, Component, ElementRef, Inject, ViewChild } from '@angular/core';
import { AuthorizationService } from 'src/app/core/services/authorization/authorization.service';
import { GoogleAuthenticationService } from 'src/app/core/services/login/google-authentication.service'
import { ConfigService } from "../../core/services/config/config.service";
import { NotificationService } from 'src/app/shared/services/notification.service';
import { Role } from 'src/app/models/Role';
import { GoogleUser } from 'src/app/models/GoogleUser';
import jwt_decode from "jwt-decode";
import { ROLES, setItemInSessionStorage } from 'src/app/utils/SessionStorageUtil';
import { CrewInfoStore } from 'src/app/core/services/crew-info/crew-info.store';
import { PrivacyPolicyComponent } from './privacy-policy/privacy-policy.component';
import { MatDialog } from '@angular/material/dialog';
import { WindowService } from 'src/app/core/services/window/window.service';
import { Router } from '@angular/router';

declare const gapi: any;

// interface
// servicio latam


@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss'],
  standalone: false
})
export class LoginComponent implements AfterViewInit {

  @ViewChild('loginGoogleBtn') loginGoogleBtn: ElementRef;

  loggedIn: boolean;
  errorLogin: boolean;
  auth2: any;

  constructor(private authorizationService: AuthorizationService,
    private configService: ConfigService,
    private googleAuthenticationService: GoogleAuthenticationService,
    private notificationService: NotificationService,
    private dialog: MatDialog,
    private windowService: WindowService,
    private crewInfoStore: CrewInfoStore,
    private router: Router) { }

  ngAfterViewInit(): void {
    if (this.googleAuthenticationService.isAuthorized()) {
      this.getRoles();
      return
    }

    this.googleInit();
  }

  public googleInit(): void {
    let that = this;
    gapi.load('auth2', () => {
      that.auth2 = gapi.auth2.init({
        client_id: this.configService.GSuiteClientID,
        cookiepolicy: 'single_host_origin',
        hosted_domain: 'latam.com',
        prompt: 'consent'
      });
      that.attachSignin(document.getElementById('loginGoogleBtn'));
    });
  }

  public attachSignin(element: any): void {
    this.auth2.attachClickHandler(element, {},
      (googleUser: any) => {
        if (googleUser.getBasicProfile() != undefined) {
          this.handleCredentialResponse(googleUser);
        } else {
          this.attachSignin(document.getElementById('loginGoogleBtn'));
        }
      }, () => {
        this.notificationService.error('Houve um problema no login. Por favor, tente novamente!');
      });
  }

  handleCredentialResponse(response: any): void {
    const idToken = response.getAuthResponse().id_token;
    const payloadToken: any = jwt_decode(idToken);

    sessionStorage.clear();
    this.crewInfoStore.clear();

    this.googleAuthenticationService.setAccessToken(idToken);
    this.googleAuthenticationService.setGoogleUser(new GoogleUser(payloadToken.given_name, payloadToken.email, payloadToken.picture));

    this.getRoles();

    this.loggedIn = true;
  }

  getRoles(): void {
    this.authorizationService.getRoles().subscribe({
      next: (response: Role) => {
        setItemInSessionStorage(ROLES, response);
        this.windowService.navigate('/home');
      },
      error: (error) => {
        if (error.status === 401) {
          this.notificationService.error('Usuário sem permissão.', 'Para solicitar clique aqui.')
            .onAction()
            .subscribe(() => window.open('http://localhost', "_blank"));
        } else {
          this.notificationService.error('Ocorreu um erro inesperado ao tentar recuperar as permissões.');
        }
      },
    });
  }

  public openPrivacyPolicy(): void {
    this.dialog.open(PrivacyPolicyComponent, {
      width: '700px',
      height: '95%',
      autoFocus: false,
    });
  }

  toExternalLogin(): void {
    this.router.navigate(['/external-login']);
  }
}
